<template>
    <div class="overviewRight white border-radius5 mar-bot10">
        <div class="account-header">
          <div class="nickname-line">
              <span class="nickname-title fs12">{{alias || login}}</span>
              <span class="mam-title copytype-title tag">{{$t('Ordinary_account')}}</span>
          </div>
          <account-index-data-new
            @send-indexdata="sendIndexDataHandle"
          ></account-index-data-new>
        </div>
        <div class="account-bottom">
            <div ref="echartup" class="chart-box pc-padtop30-mobil-padtop20">
                <account-bar
                        :chart-width="echarWidth"
                        :height="echarHeight"
                        :chart-list="levelData"
                ></account-bar>
            </div>
            <div class="rate-box center pc-padding30-mobil-padding20">
                <el-rate
                        disabled
                        :value="recommendStar"
                        show-score
                        :colors="[orange,orange,orange]"
                        text-color="#999999"
                ></el-rate>
            </div>
        </div>
    </div>
</template>

<script>
  import accountIndexDataNew from "@/components/common/accountIndexDataNew";
  import { getTraderOverview } from '@/api/copy'
  import accountBar from '@/components/echarts/accountBar'
  export default {
    name: 'overviewRight',
    components:{
      accountBar,
      accountIndexDataNew
    },
    data() {
      return {
        echarWidth: 0,
        echarHeight: 184,
        orange: '#FF7F5A',
        levelData:[],
        recommendStar: 0,
        alias: '',
        businessType: '',
        login: ''
      };
    },
    created(){
      this.getOverView();
    },
    mounted(){
      this.echarWidth = this.$refs.echartup.clientHeight;
    },
    methods: {
      getOverView(){
        getTraderOverview({
          mtId: +this.$route.params.mtid,
        }).then((res) => {
          this.login = res.data.login;
          this.alias = res.data.alias;
          this.businessType = res.data.businessType;
          this.recommendStar = res.data.recommendStar;
          this.levelData.push(res.data.profitAbility);
          this.levelData.push(res.data.robustAbility);
          this.levelData.push(res.data.riskControlAbility);
          this.levelData.push(res.data.capitalSize);
          this.levelData.push(res.data.tradingActivity);
        })
      },
      sendIndexDataHandle(accountInfo){
        this.$emit('send-indexdata', accountInfo);
      }
    }
  };
</script>

<style lang="scss" scoped>
    .overviewRight {
        .account-header {
            padding: 30px;
            padding-bottom: 10px;
            .nickname-line {
                margin-bottom: 10px;
            }
            .nickname-title {
                display: inline-block;
                margin-right: 10px;
                font-size: 16px;
                font-weight: bold;
                color: #333333;
            }
            .tag {
                background-color: rgba(255,127,90, .1);
                color: #FF7F5A;
            }
            .money-limit {
                color: #999999;
                margin-bottom: 20px;
            }
            .copy-btn {
                width: 100%;
            }
        }
        .account-bottom {
            .rate-box {
                margin-bottom: 32px;
            }
        }
    }
</style>
